import React, { useEffect } from 'react'
import { useLogoutMutation } from '@/shared/hooks/queries/useAuthMutations'

export const LogoutPage: React.FC = () => {
  const logoutMutation = useLogoutMutation()

  useEffect(() => {
    logoutMutation.mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <p>Logging out...</p>
}
